import * as ProRegularSvgIcons from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classnames from 'classnames'
import { format, parseISO } from 'date-fns'
import * as React from 'react'
import { useTranslatable } from 'src/hooks/locale/utils'
import { isDeadlinePassed } from './validation'

/**
 * The `🕒 dd.mm` line legacy prints under a criterion's header — muted while entry is open, red
 * once the deadline has passed and the column is locked.
 */
export default function CriteriaDeadline({
  deadline,
}: {
  readonly deadline: string | null | undefined
}): React.ReactElement | null {
  const t = useTranslatable()
  if (deadline == null || deadline === '') return null

  const date = parseISO(deadline)
  return (
    <small
      className={classnames('whitespace-nowrap', isDeadlinePassed(deadline) ? 'text-primaryRed' : 'text-captionColor')}
      style={{ fontSize: '12px' }}
      title={`${t('course:criteria_deadline')} ${format(date, 'dd.MM.yyyy')}`}
    >
      <FontAwesomeIcon icon={ProRegularSvgIcons.faClock} className="mr-1" />
      {format(date, 'dd.MM')}
    </small>
  )
}
